export const paramsInputList = [
  /*
  * 数组下标 -- 行业
  * */
  // 0--默认为空
  {
    title: [],
    input: [[]]
  },
  // 1--钢铁生产
  {
    title: ['化石燃料燃烧排放', '工业生产过程排放（溶剂消耗量）', '产品产量（固碳产品隐含的排放）', '外购电力', '外购热力'],
    pieChartTitle: ['燃料', '溶剂', '产品', '外购电力', '外购热力'],
    input: [
      [
        {
          value: '',
          label: '无烟煤',
          placeholder: '单位：吨',
          factor: 26.7 * 0.094748
        },
        {
          value: '',
          label: '烟煤',
          placeholder: '单位：吨',
          factor: 19.57 * 0.0893
        },
        {
          value: '',
          label: '褐煤',
          placeholder: '单位：吨',
          factor: 11.9 * 0.09856
        },
        {
          value: '',
          label: '洗精煤',
          placeholder: '单位：吨',
          factor: 26.334 * 0.086614
        },
        {
          value: '',
          label: '型煤',
          placeholder: '单位：吨',
          factor: 17.46 * 0.11088
        },
        {
          value: '',
          label: '焦炭',
          placeholder: '单位：吨',
          factor: 28.435 * 0.100254
        },
        {
          value: '',
          label: '原油',
          placeholder: '单位：吨',
          factor: 41.816 * 0.072226
        },
        {
          value: '',
          label: '燃料油',
          placeholder: '单位：吨',
          factor: 41.816 * 0.075819
        },
        {
          value: '',
          label: '汽油',
          placeholder: '单位：吨',
          factor: 43.07 * 0.067914
        },
        {
          value: '',
          label: '柴油',
          placeholder: '单位：吨',
          factor: 42.652 * 0.07258
        },
        {
          value: '',
          label: '石油焦',
          placeholder: '单位：吨',
          factor: 32.5 * 0.09882
        },
        {
          value: '',
          label: '炼厂干气',
          placeholder: '单位：吨',
          factor: 46.05 * 0.066066
        },
        {
          value: '',
          label: '液化石油气',
          placeholder: '单位：吨',
          factor: 47.31 * 0.062436
        },
        {
          value: '',
          label: '液化天然气',
          placeholder: '单位：吨',
          factor: 41.868 * 0.062436
        },
        {
          value: '',
          label: '天然气',
          placeholder: '单位：万标准立方米',
          factor: 389.31 * 0.055539
        }
      ],
      [
        {
          value: '',
          label: '石灰石',
          placeholder: '单位：吨',
          factor: 0.44
        },
        {
          value: '',
          label: '白云石',
          placeholder: '单位：吨',
          factor: 0.471
        },
        {
          value: '',
          label: '电极',
          placeholder: '单位：吨',
          factor: 3.663
        },
        {
          value: '',
          label: '生铁',
          placeholder: '单位：吨',
          factor: 0.172
        },
        {
          value: '',
          label: '直接还原铁',
          placeholder: '单位：吨',
          factor: 0.073
        },
        {
          value: '',
          label: '镍铁合金',
          placeholder: '单位：吨',
          factor: 0.037
        },
        {
          value: '',
          label: '铬铁合金',
          placeholder: '单位：吨',
          factor: 0.275
        }
      ],
      [
        {
          value: '',
          label: '粗钢产量',
          placeholder: '单位：吨',
          factor: 0.0154
        },
        {
          value: '',
          label: '生铁产量',
          placeholder: '单位：吨',
          factor: 0.172
        },
        {
          value: '',
          label: '甲醇产量',
          placeholder: '单位：吨',
          factor: 1.375
        }
      ],
      [
        {
          value: '',
          label: '外购电力',
          placeholder: '单位：MWh',
          factor: 0.9419
        }
      ],
      [
        {
          value: '',
          label: '外购热力',
          placeholder: '单位：吉焦(GJ)',
          factor: 0.11
        }
      ]
    ]
  },
  // 2--发电
  {
    title: ['化石燃料燃烧排放', '外购电力'],
    pieChartTitle: ['燃料', '外购电力'],
    input: [
      [
        // 碳排放量（tCO2）= 燃料消耗量*平均低位发热量*碳排放因子
        {
          value: '',
          label: '无烟煤',
          placeholder: '单位：吨',
          factor: 25.0896 * 0.0948
        },
        {
          value: '',
          label: '一般烟煤',
          placeholder: '单位：吨',
          factor: 20.908 * 0.0894
        },
        {
          value: '',
          label: '褐煤',
          placeholder: '单位：吨',
          factor: 12.5448 * 0.0986
        },
        {
          value: '',
          label: '洗精煤',
          placeholder: '单位：吨',
          factor: 25.0896 * 0.0867
        },
        {
          value: '',
          label: '焦炭',
          placeholder: '单位：吨',
          factor: 28.43488 * 0.1003
        },
        {
          value: '',
          label: '天然气',
          placeholder: '单位：万标准立方米',
          factor: 355.436 * 0.0556
        },
        {
          value: '',
          label: '原油',
          placeholder: '单位：吨',
          factor: 41.816 * 0.0723
        },
        {
          value: '',
          label: '汽油',
          placeholder: '单位：吨',
          factor: 43.07048 * 0.06797574
        },
        {
          value: '',
          label: '煤油',
          placeholder: '单位：吨',
          factor: 43.07048 * 0.0705
        },
        {
          value: '',
          label: '柴油',
          placeholder: '单位：吨',
          factor: 42.65232 * 0.07265132
        }
      ],
      [
        {
          value: '',
          label: '外购电力',
          placeholder: '单位：MWh',
          factor: 0.9419
        }
      ]
    ]
  },
  // 3--电网--空
  {
    title: [],
    pieChartTitle: [],
    input: [[]]
  },
  // 4--民用航空
  {
    title: ['化石燃料燃烧排放', '外购电力', '外购热力'],
    pieChartTitle: ['燃料', '外购电力', '外购热力'],
    input: [
      [
        // 碳排放量（tCO2）= 燃料消耗量*平均低位发热量*碳排放因子
        {
          value: '',
          label: '无烟煤',
          placeholder: '单位：吨',
          factor: 23.210 * 0.0944
        },
        {
          value: '',
          label: '烟煤',
          placeholder: '单位：吨',
          factor: 22.350 * 0.0890
        },
        {
          value: '',
          label: '褐煤',
          placeholder: '单位：吨',
          factor: 14.080 * 0.0986
        },
        {
          value: '',
          label: '型煤',
          placeholder: '单位：吨',
          factor: 17.460 * 0.11088
        },
        {
          value: '',
          label: '焦炭',
          placeholder: '单位：吨',
          factor: 28.435 * 0.100595
        },
        {
          value: '',
          label: '原油',
          placeholder: '单位：吨',
          factor: 41.816 * 0.072226
        },
        {
          value: '',
          label: '燃料油',
          placeholder: '单位：吨',
          factor: 41.816 * 0.075819
        },
        {
          value: '',
          label: '汽油',
          placeholder: '单位：吨',
          factor: 43.07048 * 0.067914
        },
        {
          value: '',
          label: '一般煤油',
          placeholder: '单位：吨',
          factor: 43.07048 * 0.070429
        },
        {
          value: '',
          label: '航空汽油',
          placeholder: '单位：吨',
          factor: 44.300 * 0.07
        },
        {
          value: '',
          label: '航空煤油',
          placeholder: '单位：吨',
          factor: 44.100 * 0.0715
        },
        {
          value: '',
          label: '液化石油气',
          placeholder: '单位：吨',
          factor: 50.179 * 0.061805
        },
        {
          value: '',
          label: '液化天然气',
          placeholder: '单位：吨',
          factor: 41.868 * 0.061805
        },
        {
          value: '',
          label: '炼厂干气',
          placeholder: '单位：吨',
          factor: 45.998 * 0.0653986
        },
        {
          value: '',
          label: '石脑油',
          placeholder: '单位：吨',
          factor: 44.500 * 0.07186
        },
        {
          value: '',
          label: '石油焦',
          placeholder: '单位：吨',
          factor: 32.500 * 0.098816
        },
        {
          value: '',
          label: '其它石油制品',
          placeholder: '单位：吨',
          factor: 40.200 * 0.07186
        },
        {
          value: '',
          label: '液化天然气',
          placeholder: '单位：万标准立方米',
          factor: 38.931 * 0.055539
        },
        {
          value: '',
          label: '焦炉煤气',
          placeholder: '单位：万标准立方米',
          factor: 17.406 * 0.049368
        },
        {
          value: '',
          label: '其他煤气',
          placeholder: '单位：万标准立方米',
          factor: 15.7584 * 0.044286
        }
      ],
      [
        {
          value: '',
          label: '外购电力',
          placeholder: '单位：MWh',
          factor: 0.9419
        }
      ],
      [
        // 购入热力*热力碳排放因子
        {
          value: '',
          label: '外购热力',
          placeholder: '单位：GJ',
          factor: 0.11
        }
      ]
    ]
  },
  // 5--独立焦化--单独算法-ok
  {
    title: ['化石燃料燃烧排放', '回收利用', '外购电力', '外购热力'],
    pieChartTitle: ['燃料', '回收利用', '外购电力', '外购热力'],
    input: [
      [
        {
          value: '',
          label: '无烟煤',
          placeholder: '单位：吨',
          factor: 20.304 * 0.094748
        },
        {
          value: '',
          label: '烟煤',
          placeholder: '单位：吨',
          factor: 19.57 * 0.0892738
        },
        {
          value: '',
          label: '褐煤',
          placeholder: '单位：吨',
          factor: 14.08 * 0.09856
        },
        {
          value: '',
          label: '洗精煤',
          placeholder: '单位：吨',
          factor: 29.727 * 0.086614
        },
        {
          value: '',
          label: '型煤',
          placeholder: '单位：吨',
          factor: 17.46 * 0.11088
        },
        {
          value: '',
          label: '焦炭',
          placeholder: '单位：吨',
          factor: 28.469 * 0.100254
        },
        {
          value: '',
          label: '原油',
          placeholder: '单位：吨',
          factor: 42.62 * 0.072226
        },
        {
          value: '',
          label: '燃料油',
          placeholder: '单位：吨',
          factor: 40.19 * 0.075819
        },
        {
          value: '',
          label: '汽油',
          placeholder: '单位：吨',
          factor: 44.8 * 0.067914
        },
        {
          value: '',
          label: '柴油',
          placeholder: '单位：吨',
          factor: 43.33 * 0.07258
        },
        {
          value: '',
          label: '石油焦',
          placeholder: '单位：吨',
          factor: 31.998 * 0.098816
        },
        {
          value: '',
          label: '煤焦油',
          placeholder: '单位：吨',
          factor: 33.496 * 0.07905
        },
        {
          value: '',
          label: '炼厂干气',
          placeholder: '单位：吨',
          factor: 46.05 * 0.066066
        },
        {
          value: '',
          label: '液化石油气',
          placeholder: '单位：吨',
          factor: 47.31 * 0.062436
        },
        {
          value: '',
          label: '炼厂干气',
          placeholder: '单位：吨',
          factor: 41.868 * 0.062436
        },
        {
          value: '',
          label: '天然气',
          placeholder: '单位：万标准立方米',
          factor: 389.31 * 0.055539
        },
        {
          value: '',
          label: '焦炉煤气',
          placeholder: '单位：万标准立方米',
          factor: 167.46 * 0.043923
        },
        {
          value: '',
          label: '高炉煤气',
          placeholder: '单位：万标准立方米',
          factor: 31.39 * 0.257004
        },
        {
          value: '',
          label: '转炉煤气',
          placeholder: '单位：万标准立方米',
          factor: 73.27 * 0.180048
        }
      ],
      [
        {
          value: '',
          label: '外供CO2气体体积',
          placeholder: '单位：Nm3',
          factor: 1
        },
        {
          value: '',
          label: 'CO2体积浓度',
          placeholder: '单位：%',
          factor: 1
        },
        {
          value: '',
          label: '自用CO2气体体积',
          placeholder: '单位：Nm3',
          factor: 1
        },
        {
          value: '',
          label: '自用CO2体积浓度',
          placeholder: '单位：%',
          factor: 1
        }
      ],
      [
        {
          value: '',
          label: '外购电力',
          placeholder: '单位：MWh',
          factor: 0.9419
        }
      ],
      [
        // 购入热力*热力碳排放因子
        {
          value: '',
          label: '外购热力',
          placeholder: '单位：GJ',
          factor: 0.11
        }
      ]
    ]
  },
  // 6--化工生产--空
  {
    title: [],
    pieChartTitle: [],
    input: [[]]
  },
  // 7--氟化工--单独算法--ok
  {
    title: ['化石燃料燃烧排放', 'HCFC-22生产过程HFC-23排放', '被销毁的HFC-23转化成的CO2排放',
      'HFCs/PFCs/SF6生产过程副产物及逃逸排放', '外购电力', '外购热力'],
    pieChartTitle: ['燃料', '生产过程', '外购电力', '外购热力'],
    input: [
      [
        // 碳排放量（tCO2）= 燃料消耗量*平均低位发热量*碳排放因子
        {
          value: '',
          label: '无烟煤',
          placeholder: '单位：吨',
          factor: 25.0896 * 0.0948
        },
        {
          value: '',
          label: '一般烟煤',
          placeholder: '单位：吨',
          factor: 20.908 * 0.0894
        },
        {
          value: '',
          label: '褐煤',
          placeholder: '单位：吨',
          factor: 12.5448 * 0.0986
        },
        {
          value: '',
          label: '洗精煤',
          placeholder: '单位：吨',
          factor: 25.0896 * 0.0867
        },
        {
          value: '',
          label: '天然气',
          placeholder: '单位：万标准立方米',
          factor: 355.436 * 0.0556
        },
        {
          value: '',
          label: '煤油',
          placeholder: '单位：吨',
          factor: 43.07048 * 0.0705
        },
        {
          value: '',
          label: '焦油',
          placeholder: '单位：吨',
          factor: 33.453 * 0.07913
        },
        {
          value: '',
          label: '焦炉煤气',
          placeholder: '单位：万标准立方米',
          factor: 173.854 * 0.04941
        },
        {
          value: '',
          label: '石油焦',
          placeholder: '单位：吨',
          factor: 31 * 0.09891
        },
        {
          value: '',
          label: '柴油',
          placeholder: '单位：吨',
          factor: 42.65232 * 0.07265132
        }
      ],
      [
        {
          value: '',
          label: '生产线数量',
          placeholder: '单位：条',
          factor: 0
        },
        {
          value: '',
          label: '销毁装置数量',
          placeholder: '单位：个',
          factor: 0
        },
        {
          value: '',
          label: '单条产线HCFC-22产量',
          placeholder: '单位：吨，请输入平均值',
          factor: 0
        },
        {
          value: '',
          label: 'HFC-23生成因子',
          placeholder: '单位：吨HFC-23/吨HCFC-22',
          factor: 0
        },
        {
          value: '',
          label: '以产品形式回收的HFC-23量',
          placeholder: '单位：吨，请输入平均值',
          factor: 0
        },
        {
          value: '',
          label: '进入单个销毁装置的HFC-23量',
          placeholder: '单位：吨，请输入平均值',
          factor: 0
        },
        {
          value: '',
          label: '因不完全分解从装置出口排出的HFC-23量',
          placeholder: '单位：吨，请输入平均值',
          factor: 0
        }
      ],
      [
        {
          value: '',
          label: '销毁的HFC-23量',
          placeholder: '单位：吨',
          factor: 44 / 70
        }
      ],
      [
        {
          value: '',
          label: 'HFCs或PFCs或SF6的产量',
          placeholder: '单位：吨',
          factor: 0
        },
        {
          value: '',
          label: '副产物及逃逸排放综合排放因子',
          placeholder: '单位：',
          factor: 0
        }
      ],
      [
        {
          value: '',
          label: '外购电力',
          placeholder: '单位：MWh',
          factor: 0.9419
        }
      ],
      [
        // 购入热力*热力碳排放因子
        {
          value: '',
          label: '外购热力',
          placeholder: '单位：GJ',
          factor: 0.11
        }
      ]
    ]
  },
  // 8--平板玻璃生产
  {
    title: ['化石燃料燃烧排放', '工业生产过程排放（碳粉氧化）', '工业生产过程排放（原料分解）', '外购电力', '外购热力'],
    pieChartTitle: ['燃料', '碳粉氧化', '原料分解', '外购电力', '外购热力'],
    input: [
      [
        // 碳排放量（tCO2）= 燃料消耗量*平均低位发热量*碳排放因子
        {
          value: '',
          label: '无烟煤',
          placeholder: '单位：吨',
          factor: 25.0896 * 0.0948
        },
        {
          value: '',
          label: '一般烟煤',
          placeholder: '单位：吨',
          factor: 20.908 * 0.0894
        },
        {
          value: '',
          label: '褐煤',
          placeholder: '单位：吨',
          factor: 12.5448 * 0.0986
        },
        {
          value: '',
          label: '洗精煤',
          placeholder: '单位：吨',
          factor: 25.0896 * 0.0867
        },
        {
          value: '',
          label: '天然气',
          placeholder: '单位：万标准立方米',
          factor: 355.436 * 0.0556
        },
        {
          value: '',
          label: '煤油',
          placeholder: '单位：吨',
          factor: 43.07048 * 0.0705
        },
        {
          value: '',
          label: '焦油',
          placeholder: '单位：吨',
          factor: 33.453 * 0.07913
        },
        {
          value: '',
          label: '焦炉煤气',
          placeholder: '单位：万标准立方米',
          factor: 173.854 * 0.04941
        },
        {
          value: '',
          label: '石油焦',
          placeholder: '单位：吨',
          factor: 31 * 0.09891
        }
      ],
      [
        // 原料配料中碳粉消耗量*碳粉含碳量的加权平均值*二氧化碳与碳的数量换算
        {
          value: '',
          label: '原料配料碳粉',
          placeholder: '单位：吨',
          factor: 3.6667
        }
      ],
      [
        // 碳酸盐重量*碳酸盐特定碳排放因子*碳酸盐煅烧比例
        {
          value: '',
          label: '碳酸钙',
          placeholder: '单位：吨',
          factor: 0.43971 * 0.1
        },
        {
          value: '',
          label: '碳酸镁',
          placeholder: '单位：吨',
          factor: 0.52197 * 0.1
        },
        {
          value: '',
          label: '白云石',
          placeholder: '单位：吨',
          factor: 0.47732 * 0.1
        },
        {
          value: '',
          label: '碳酸铁',
          placeholder: '单位：吨',
          factor: 0.37987 * 0.1
        },
        {
          value: '',
          label: 'Ca(Fe,Mg,Mn)(CO3)2',
          placeholder: '单位：吨',
          factor: 0.44197 * 0.1
        },
        {
          value: '',
          label: '碳酸锰',
          placeholder: '单位：吨',
          factor: 0.38286 * 0.1
        },
        {
          value: '',
          label: '碳酸钠',
          placeholder: '单位：吨',
          factor: 0.41492 * 0.1
        }
      ],
      [
        // 购入电量*区域因子
        {
          value: '',
          label: '外购电力',
          placeholder: '单位：MWh',
          factor: 0.9419
        }
      ],
      [
        // 购入热力*热力碳排放因子
        {
          value: '',
          label: '外购热力',
          placeholder: '单位：GJ',
          factor: 0.11
        }
      ]
    ]
  },
  // 9--水泥生产--单独算法--ok
  {
    title: ['化石燃料燃烧排放', '工业生产过程排放（燃烧排放）', '工业生产过程排放（原料分解）', '工业生产过程排放（非燃烧排放）', '外购电力', '外购热力'],
    pieChartTitle: ['燃料', '燃烧排放', '原料分解', '非燃烧排放', '外购电力', '外购热力'],
    input: [
      [
        // 碳排放量（tCO2）= 燃料消耗量*平均低位发热量*碳排放因子
        {
          value: '',
          label: '无烟煤',
          placeholder: '单位：吨',
          factor: 25.0896 * 0.0948
        },
        {
          value: '',
          label: '一般烟煤',
          placeholder: '单位：吨',
          factor: 20.908 * 0.0894
        },
        {
          value: '',
          label: '褐煤',
          placeholder: '单位：吨',
          factor: 12.5448 * 0.0986
        },
        {
          value: '',
          label: '洗精煤',
          placeholder: '单位：吨',
          factor: 25.0896 * 0.0867
        },
        {
          value: '',
          label: '天然气',
          placeholder: '单位：万标准立方米',
          factor: 355.436 * 0.0556
        },
        {
          value: '',
          label: '煤油',
          placeholder: '单位：吨',
          factor: 43.07048 * 0.0705
        },
        {
          value: '',
          label: '焦油',
          placeholder: '单位：吨',
          factor: 33.453 * 0.07913
        },
        {
          value: '',
          label: '焦炉煤气',
          placeholder: '单位：万标准立方米',
          factor: 173.854 * 0.04941
        },
        {
          value: '',
          label: '石油焦',
          placeholder: '单位：吨',
          factor: 31 * 0.09891
        }
      ],
      [
        // 燃料或废弃物的用量*燃料或废弃物的加权平均低位发热量*燃料或废弃物的碳排放因子
        {
          value: '',
          label: '废油',
          placeholder: '单位：吨',
          factor: 40.2 * 0.074 * 1
        },
        {
          value: '',
          label: '废轮胎',
          placeholder: '单位：吨',
          factor: 31.4 * 0.085 * 0.2
        },
        {
          value: '',
          label: '塑料',
          placeholder: '单位：吨',
          factor: 50.8 * 0.075 * 1
        },
        {
          value: '',
          label: '废溶剂',
          placeholder: '单位：吨',
          factor: 51.5 * 0.074 * 0.8
        },
        {
          value: '',
          label: '废皮革',
          placeholder: '单位：吨',
          factor: 29 * 0.11 * 0.2
        },
        {
          value: '',
          label: '废玻璃钢',
          placeholder: '单位：吨',
          factor: 32.6 * 0.083 * 1
        }
      ],
      [
        // （∑生产的水泥熟料产量+窑炉排气筒（窑头）粉尘的重量+窑炉旁边放风粉尘的重量）
        // ×[（熟料中氧化钙含量-熟料中不是来源于碳酸盐分解的氧化钙含量）×二氧化碳与氧化钙之间的分子量换算
        // +（熟料中氧化镁含量-熟料中不是来源于碳酸盐分解的氧化镁含量）×二氧化碳与氧化镁之间的分子量换算]
        {
          value: '',
          label: '生产的水泥熟料产量',
          placeholder: '单位：吨',
          factor: 1
        },
        {
          value: '',
          label: '窑炉排气筒（窑头）粉尘的重量',
          placeholder: '单位：吨',
          factor: 1
        },
        {
          value: '',
          label: '窑炉旁边放风粉尘的重量',
          placeholder: '单位：吨',
          factor: 1
        },
        {
          value: '',
          label: '熟料中氧化钙含量',
          placeholder: '单位：%',
          factor: 1
        },
        {
          value: '',
          label: '熟料中不是来源于碳酸盐分解的氧化钙含量',
          placeholder: '单位：%',
          factor: 1
        },
        {
          value: '',
          label: '熟料中氧化镁含量',
          placeholder: '单位：%',
          factor: 1
        },
        {
          value: '',
          label: '熟料中不是来源于碳酸盐分解的氧化镁含量',
          placeholder: '单位：%',
          factor: 1
        }
      ],
      [
        // 生料的数量×生料中非燃料碳含量×二氧化碳与碳的数量换算
        {
          value: '',
          label: '生料',
          placeholder: '单位：吨',
          factor: 0.003 * 3.6667
        }
      ],
      [
        // 购入电量*区域因子
        {
          value: '',
          label: '外购电力',
          placeholder: '单位：MWh',
          factor: 0.9419
        }
      ],
      [
        // 购入热力*热力碳排放因子
        {
          value: '',
          label: '外购热力',
          placeholder: '单位：吉焦(GJ)',
          factor: 0.11
        }
      ]
    ]
  },
  // 10--石油和天然气生产--单独算法--没看懂
  {
    title: ['化石燃料燃烧排放', '火炬燃烧排放', '工业生产过程排放（油气勘探业务）',
      '工业生产过程排放（油气开采业务）', '工业生产过程排放（油气处理业务）', '工业生产过程排放（油气储运业务）',
      '工业生产过程排放（CH4回收利用量）', '工业生产过程排放（CO2回收利用量）', '外购电力', '外购热力'],
    pieChartTitle: ['燃料', '火炬燃烧', '油气勘探', '油气开采', '油气处理', '油气储运',
      'CH4回收利用', 'CO2回收利用', '外购电力', '外购热力'],
    input: [
      [
        // 碳排放量（tCO2）= 燃料消耗量*平均低位发热量*碳排放因子
        {
          value: '',
          label: '无烟煤',
          placeholder: '单位：吨',
          factor: 25.0896 * 0.0948
        },
        {
          value: '',
          label: '一般烟煤',
          placeholder: '单位：吨',
          factor: 20.908 * 0.0894
        },
        {
          value: '',
          label: '褐煤',
          placeholder: '单位：吨',
          factor: 12.5448 * 0.0986
        },
        {
          value: '',
          label: '洗精煤',
          placeholder: '单位：吨',
          factor: 25.0896 * 0.0867
        },
        {
          value: '',
          label: '天然气',
          placeholder: '单位：万标准立方米',
          factor: 355.436 * 0.0556
        },
        {
          value: '',
          label: '煤油',
          placeholder: '单位：吨',
          factor: 43.07048 * 0.0705
        },
        {
          value: '',
          label: '焦油',
          placeholder: '单位：吨',
          factor: 33.453 * 0.07913
        },
        {
          value: '',
          label: '焦炉煤气',
          placeholder: '单位：万标准立方米',
          factor: 173.854 * 0.04941
        },
        {
          value: '',
          label: '石油焦',
          placeholder: '单位：吨',
          factor: 31 * 0.09891
        },
        {
          value: '',
          label: '柴油',
          placeholder: '单位：吨',
          factor: 42.65232 * 0.07265
        }
      ],
      [
        // 火炬燃烧排放
        {
          value: '',
          label: '废油',
          placeholder: '单位：吨',
          factor: 40.2 * 0.074 * 1
        }
      ],
      [
        {
          value: '',
          label: '？？？',
          placeholder: '单位：吨',
          factor: 1
        }
      ],
      [
        {
          value: '',
          label: '？？？',
          placeholder: '单位：吨',
          factor: 1
        }
      ],
      [
        {
          value: '',
          label: '？？？',
          placeholder: '单位：吨',
          factor: 1
        }
      ],
      [
        {
          value: '',
          label: '？？？',
          placeholder: '单位：吨',
          factor: 1
        }
      ],
      [
        {
          value: '',
          label: ' CH4回收利用量',
          placeholder: '单位：吨CH4',
          factor: 1
        }
      ],
      [
        {
          value: '',
          label: 'CO2回收利用量',
          placeholder: '单位：吨CO2',
          factor: 1
        }
      ],
      [
        // 购入电量*区域因子
        {
          value: '',
          label: '外购电力',
          placeholder: '单位：MWh',
          factor: 0.9419
        }
      ],
      [
        // 购入热力*热力碳排放因子
        {
          value: '',
          label: '外购热力',
          placeholder: '单位：吉焦(GJ)',
          factor: 0.11
        }
      ]
    ]
  },
  // 11--石油化工--单独算法
  {
    title: ['化石燃料燃烧排放', '工业生产过程排放（催化裂化）', '工业生产过程排放（制氢装置）', '外购电力', '外购热力'],
    pieChartTitle: ['燃料', '催化裂化', '制氢装置', '外购电力', '外购热力'],
    input: [
      [
        {
          value: '',
          label: '无烟煤',
          placeholder: '单位：吨',
          factor: 20.304 * 0.094748
        },
        {
          value: '',
          label: '烟煤',
          placeholder: '单位：吨',
          factor: 19.57 * 0.0892738
        },
        {
          value: '',
          label: '褐煤',
          placeholder: '单位：吨',
          factor: 14.08 * 0.09856
        },
        {
          value: '',
          label: '型煤',
          placeholder: '单位：吨',
          factor: 14.46 * 0.11088
        },
        {
          value: '',
          label: '焦炭',
          placeholder: '单位：吨',
          factor: 28.447 * 0.100254
        },
        {
          value: '',
          label: '原油',
          placeholder: '单位：吨',
          factor: 42.62 * 0.072226
        },
        {
          value: '',
          label: '燃料油',
          placeholder: '单位：吨',
          factor: 40.19 * 0.075819
        },
        {
          value: '',
          label: '汽油',
          placeholder: '单位：吨',
          factor: 44.8 * 0.067914
        },
        {
          value: '',
          label: '柴油',
          placeholder: '单位：吨',
          factor: 43.33 * 0.07258
        },
        {
          value: '',
          label: '石油焦',
          placeholder: '单位：吨',
          factor: 31.998 * 0.098816
        },
        {
          value: '',
          label: '焦油',
          placeholder: '单位：吨',
          factor: 33.453 * 0.07905
        },
        {
          value: '',
          label: '炼厂干气',
          placeholder: '单位：吨',
          factor: 46.05 * 0.066066
        },
        {
          value: '',
          label: '液化石油气',
          placeholder: '单位：吨',
          factor: 47.31 * 0.062436
        },
        {
          value: '',
          label: '炼厂干气',
          placeholder: '单位：吨',
          factor: 41.868 * 0.062436
        },
        {
          value: '',
          label: '液化天然气',
          placeholder: '单位：吨',
          factor: 41.868 * 0.062436
        },
        {
          value: '',
          label: '天然气',
          placeholder: '单位：万标准立方米',
          factor: 389.31 * 0.055539
        }
      ],
      [
        {
          value: '',
          label: '燃料焦炭燃烧量',
          placeholder: '单位：吨',
          factor: 1
        },
        {
          value: '',
          label: '焦炭含碳量',
          placeholder: '单位：吨',
          factor: 44 / 12
        }
      ],
      [
        {
          value: '',
          label: '原料量',
          placeholder: '单位：吨',
          factor: 1
        },
        {
          value: '',
          label: '焦炭含碳量',
          placeholder: '单位：吨',
          factor: 44 / 12
        }
      ],
      [
        {
          value: '',
          label: '外购电力',
          placeholder: '单位：MWh',
          factor: 0.9419
        }
      ],
      [
        {
          value: '',
          label: '外购热力',
          placeholder: '单位：吉焦(GJ)',
          factor: 0.11
        }
      ]
    ]
  },
  // 12--电解铝
  {
    title: ['化石燃料燃烧排放', '能源作为原材料用途的排放', '工业生产过程（阳极效应）', '工业生产过程（煅烧石灰石）', '外购电力', '外购热力'],
    pieChartTitle: ['燃料', '能源', '阳极效应', '煅烧石灰石', '外购电力', '外购热力'],
    input: [
      [
        {
          value: '',
          label: '无烟煤',
          placeholder: '单位：吨',
          factor: 25.0896 * 0.0948
        },
        {
          value: '',
          label: '一般烟煤',
          placeholder: '单位：吨',
          factor: 20.908 * 0.0894
        },
        {
          value: '',
          label: '褐煤',
          placeholder: '单位：吨',
          factor: 12.5448 * 0.09856
        },
        {
          value: '',
          label: '洗精煤',
          placeholder: '单位：吨',
          factor: 25.0896 * 0.0867
        },
        {
          value: '',
          label: '天然气',
          placeholder: '单位：万标准立方米',
          factor: 355.436 * 0.0556
        },
        {
          value: '',
          label: '煤油',
          placeholder: '单位：吨',
          factor: 43.07048 * 0.0705
        },
        {
          value: '',
          label: '焦油',
          placeholder: '单位：吨',
          factor: 33.453 * 0.07913
        },
        {
          value: '',
          label: '焦炉煤气',
          placeholder: '单位：万标准立方米',
          factor: 173.854 * 0.04941
        },
        {
          value: '',
          label: '石油焦',
          placeholder: '单位：吨',
          factor: 31 * 0.09891
        }
      ],
      [
        {
          value: '',
          label: '原铝产量',
          placeholder: '单位：吨',
          factor: 0.9997
        }
      ],
      [
        // （6500×阳极效应的CF4排放因子+9200×阳极效应的C2F6排放因子）×原铝产量/1000
        {
          value: '',
          label: '原铝产量',
          placeholder: '单位：吨',
          factor: (6500 * 0.034 + 9200 * 0.0034) / 1000
        }
      ],
      [
        {
          value: '',
          label: '石灰石',
          placeholder: '单位：吨',
          factor: 0.405
        }
      ],
      [
        {
          value: '',
          label: '外购电力',
          placeholder: '单位：MWh',
          factor: 0.9419
        }
      ],
      [
        {
          value: '',
          label: '外购热力',
          placeholder: '单位：吉焦(GJ)',
          factor: 0.11
        }
      ]
    ]
  },
  // 13--镁冶炼
  {
    title: ['化石燃料燃烧排放', '能源作为原材料用途的排放', '工业生产过程（煅烧石灰石）', '外购电力', '外购热力'],
    pieChartTitle: ['燃料', '能源', '煅烧石灰石', '外购电力', '外购热力'],
    input: [
      [
        {
          value: '',
          label: '无烟煤',
          placeholder: '单位：吨',
          factor: 25.0896 * 0.0948
        },
        {
          value: '',
          label: '一般烟煤',
          placeholder: '单位：吨',
          factor: 20.908 * 0.0894
        },
        {
          value: '',
          label: '褐煤',
          placeholder: '单位：吨',
          factor: 12.5448 * 0.09856
        },
        {
          value: '',
          label: '洗精煤',
          placeholder: '单位：吨',
          factor: 25.0896 * 0.0867
        },
        {
          value: '',
          label: '天然气',
          placeholder: '单位：万标准立方米',
          factor: 355.436 * 0.0556
        },
        {
          value: '',
          label: '煤油',
          placeholder: '单位：吨',
          factor: 43.07048 * 0.0705
        },
        {
          value: '',
          label: '焦油',
          placeholder: '单位：吨',
          factor: 33.453 * 0.07913
        },
        {
          value: '',
          label: '焦炉煤气',
          placeholder: '单位：万标准立方米',
          factor: 173.854 * 0.04941
        },
        {
          value: '',
          label: '石油焦',
          placeholder: '单位：吨',
          factor: 31 * 0.09891
        },
        {
          value: '',
          label: '柴油',
          placeholder: '单位：吨',
          factor: 42.65232 * 0.07265
        }
      ],
      [
        {
          value: '',
          label: '自产硅铁产量',
          placeholder: '单位：吨',
          factor: 2.79
        }
      ],
      [
        {
          value: '',
          label: '白云石原料消耗量',
          placeholder: '单位：吨',
          factor: 0.478
        }
      ],
      [
        {
          value: '',
          label: '外购电力',
          placeholder: '单位：MWh',
          factor: 0.9419
        }
      ],
      [
        {
          value: '',
          label: '外购热力',
          placeholder: '单位：吉焦(GJ)',
          factor: 0.11
        }
      ]
    ]
  },
  // 14--其他有色金属--单独算法--ok
  {
    title: ['燃料消耗量', '能源消耗量', '工业生产过程碳排放', '外购电力', '外购热力'],
    pieChartTitle: ['燃料', '能源', '工业生产', '外购电力', '外购热力'],
    input: [
      [
        // 碳排放量（tCO2）= 燃料消耗量*平均低位发热量*碳排放因子
        {
          value: '',
          label: '无烟煤',
          placeholder: '单位：吨',
          factor: 25.0896 * 0.0948
        },
        {
          value: '',
          label: '一般烟煤',
          placeholder: '单位：吨',
          factor: 20.908 * 0.0894
        },
        {
          value: '',
          label: '褐煤',
          placeholder: '单位：吨',
          factor: 12.5448 * 0.0986
        },
        {
          value: '',
          label: '洗精煤',
          placeholder: '单位：吨',
          factor: 25.0896 * 0.0867
        },
        {
          value: '',
          label: '天然气',
          placeholder: '单位：万标准立方米',
          factor: 355.436 * 0.0556
        },
        {
          value: '',
          label: '煤油',
          placeholder: '单位：吨',
          factor: 43.07048 * 0.0705
        },
        {
          value: '',
          label: '焦油',
          placeholder: '单位：吨',
          factor: 33.453 * 0.07913
        },
        {
          value: '',
          label: '焦炉煤气',
          placeholder: '单位：万标准立方米',
          factor: 173.854 * 0.04941
        },
        {
          value: '',
          label: '石油焦',
          placeholder: '单位：吨',
          factor: 31 * 0.09891
        },
        {
          value: '',
          label: '柴油',
          placeholder: '单位：吨',
          factor: 42.65232 * 0.07265
        }
      ],
      [
        // 因子×消耗量
        {
          value: '',
          label: '蓝炭',
          placeholder: '单位：吨',
          factor: 2.853
        },
        {
          value: '',
          label: '焦炭',
          placeholder: '单位：吨',
          factor: 2.862
        },
        {
          value: '',
          label: '无烟煤',
          placeholder: '单位：吨',
          factor: 1.924
        },
        {
          value: '',
          label: '天然气',
          placeholder: '单位：万标准立方米',
          factor: 21.622
        }
      ],
      [
        // 草酸消耗量×0.349×草酸浓度+∑（第i种碳酸盐消耗量×第i种碳酸盐碳排放因子）
        {
          value: '',
          label: '草酸消耗量',
          placeholder: '单位：吨',
          factor: 0.349 * 0.996
        },
        {
          value: '',
          label: '纯碱',
          placeholder: '单位：吨',
          factor: 0.411
        },
        {
          value: '',
          label: '石灰石',
          placeholder: '单位：吨',
          factor: 0.405
        },
        {
          value: '',
          label: '白云石',
          placeholder: '单位：吨',
          factor: 0.468
        }
      ],
      [
        // 购入电量*区域因子
        {
          value: '',
          label: '外购电力',
          placeholder: '单位：MWh',
          factor: 0.9419
        }
      ],
      [
        // 购入热力*热力碳排放因子
        {
          value: '',
          label: '外购热力',
          placeholder: '单位：吉焦(GJ)',
          factor: 0.11
        }
      ]
    ]
  },
  // 15--造纸和纸制品生产
  {
    title: ['燃料燃烧排放阶段', '过程排放阶段', '净购入电力排放阶段', '净购入热力排放阶段'],
    pieChartTitle: ['燃料', '过程', '外购电力', '外购热力'],
    input: [
      [
        {
          value: '',
          label: '原煤',
          placeholder: '单位：吨标煤',
          factor: 1.98
        },
        {
          value: '',
          label: '天然气',
          placeholder: '单位：万标准立方米',
          factor: 2.187
        },
        {
          value: '',
          label: '柴油',
          placeholder: '单位：升',
          factor: 2.73
        },
        {
          value: '',
          label: '原油',
          placeholder: '单位：升',
          factor: 2.76
        }
      ],
      [
        {
          value: '',
          label: '石灰石',
          placeholder: '单位：吨',
          factor: 0.405
        }
      ],
      [
        {
          value: '',
          label: '外购电力',
          placeholder: '单位：MWh',
          factor: 0.9419
        }
      ],
      [
        {
          value: '',
          label: '净外购热力（热水）',
          placeholder: '单位：百万千焦',
          factor: 0.11
        },
        {
          value: '',
          label: '净外购蒸汽',
          placeholder: '单位：吨',
          factor: 0.4
        }
      ]
    ]
  },
  // 16--其他--空
  {
    title: [],
    pieChartTitle: [],
    input: [[]]
  },
  // 17--陶瓷--单独算法--ok
  {
    title: ['燃料消耗量', '工业生产过程', '外购电力'],
    pieChartTitle: ['燃料', '生产过程', '外购电力'],
    input: [
      [
        // 碳排放量（tCO2）= 燃料消耗量*平均低位发热量*碳排放因子
        {
          value: '',
          label: '无烟煤',
          placeholder: '单位：吨',
          factor: 25.0896 * 0.0948
        },
        {
          value: '',
          label: '一般烟煤',
          placeholder: '单位：吨',
          factor: 20.908 * 0.0894
        },
        {
          value: '',
          label: '褐煤',
          placeholder: '单位：吨',
          factor: 12.5448 * 0.0986
        },
        {
          value: '',
          label: '洗精煤',
          placeholder: '单位：吨',
          factor: 25.0896 * 0.0867
        },
        {
          value: '',
          label: '天然气',
          placeholder: '单位：万标准立方米',
          factor: 355.436 * 0.0556
        },
        {
          value: '',
          label: '煤油',
          placeholder: '单位：吨',
          factor: 43.07048 * 0.0705
        },
        {
          value: '',
          label: '焦油',
          placeholder: '单位：吨',
          factor: 33.453 * 0.07913
        },
        {
          value: '',
          label: '焦炉煤气',
          placeholder: '单位：万标准立方米',
          factor: 173.854 * 0.04941
        },
        {
          value: '',
          label: '石油焦',
          placeholder: '单位：吨',
          factor: 31 * 0.09891
        },
        {
          value: '',
          label: '柴油',
          placeholder: '单位：吨',
          factor: 42.65232 * 0.07265
        }
      ],
      [
        // ∑[企业原料消耗量×企业原料利用率×（使用原料中的CaCO3质量分数×0.44+使用原料中的MgCO3质量分数）×44/84]
        {
          value: '',
          label: '原料消耗量',
          placeholder: '单位：吨',
          factor: 1
        },
        {
          value: '',
          label: 'MgCO3质量分数',
          placeholder: '单位：%',
          factor: 1
        }
      ],
      [
        // 购入电量*区域因子
        {
          value: '',
          label: '外购电力',
          placeholder: '单位：MWh',
          factor: 0.9419
        }
      ]
    ]
  },
  // 18--煤炭生产--单独算法--ok
  {
    title: ['化石燃料燃烧排放', '火炬燃烧排放', '外购电力', '外购热力'],
    pieChartTitle: ['燃料', '火炬燃烧', '外购电力', '外购热力'],
    input: [
      [
        // 碳排放量（tCO2）= 燃料消耗量*平均低位发热量*碳排放因子
        {
          value: '',
          label: '无烟煤',
          placeholder: '单位：吨',
          factor: 20.304 * 0.0947
        },
        {
          value: '',
          label: '烟煤',
          placeholder: '单位：吨',
          factor: 19.57 * 0.0892738
        },
        {
          value: '',
          label: '褐煤',
          placeholder: '单位：吨',
          factor: 14.08 * 0.09856
        },
        {
          value: '',
          label: '洗精煤',
          placeholder: '单位：吨',
          factor: 29.727 * 0.086614
        },
        {
          value: '',
          label: '型煤',
          placeholder: '单位：吨',
          factor: 17.46 * 0.11088
        },
        {
          value: '',
          label: '焦炭',
          placeholder: '单位：吨',
          factor: 28.469 * 0.100254
        },
        {
          value: '',
          label: '原油',
          placeholder: '单位：吨',
          factor: 42.62 * 0.072226
        },
        {
          value: '',
          label: '燃料油',
          placeholder: '单位：吨',
          factor: 40.19 * 0.075819
        },
        {
          value: '',
          label: '汽油',
          placeholder: '单位：吨',
          factor: 44.8 * 0.067914
        },
        {
          value: '',
          label: '柴油',
          placeholder: '单位：吨',
          factor: 43.33 * 0.072585
        },
        {
          value: '',
          label: '石油焦',
          placeholder: '单位：吨',
          factor: 31.998 * 0.09882
        },
        {
          value: '',
          label: '煤焦油',
          placeholder: '单位：吨',
          factor: 33.496 * 0.07905
        },
        {
          value: '',
          label: '炼厂干气',
          placeholder: '单位：吨',
          factor: 46.05 * 0.066066
        },
        {
          value: '',
          label: '液化石油气',
          placeholder: '单位：吨',
          factor: 47.31 * 0.062436
        },
        {
          value: '',
          label: '液化天然气',
          placeholder: '单位：吨',
          factor: 41.868 * 0.062436
        },
        {
          value: '',
          label: '天然气',
          placeholder: '单位：万标准立方米',
          factor: 389.31 * 0.055539
        },
        {
          value: '',
          label: '焦炉煤气',
          placeholder: '单位：万标准立方米',
          factor: 167.46 * 0.043923
        },
        {
          value: '',
          label: '高炉煤气',
          placeholder: '单位：万标准立方米',
          factor: 31.39 * 0.257004
        },
        {
          value: '',
          label: '转炉煤气',
          placeholder: '单位：万标准立方米',
          factor: 73.27 * 0.180048
        }
      ],
      [
        {
          value: '',
          label: '煤气层火炬燃烧量',
          placeholder: '单位：Nm3',
          factor: 0.0154
        },
        {
          value: '',
          label: '其他含碳化合物总含碳量',
          placeholder: '单位：tCO2/Nm3',
          factor: 0.172
        },
        {
          value: '',
          label: '火炬燃烧碳氧化率',
          placeholder: '单位：%',
          factor: 0.01
        }
      ],
      [
        {
          value: '',
          label: '外购电力',
          placeholder: '单位：MWh',
          factor: 0.9419
        }
      ],
      [
        {
          value: '',
          label: '外购热力',
          placeholder: '单位：吉焦(GJ)',
          factor: 0.11
        }
      ]
    ]
  },
  // 19--公共建筑
  {
    title: ['化石燃料燃烧排放', '外购电力', '外购热力'],
    pieChartTitle: ['燃料', '外购电力', '外购热力'],
    input: [
      [
        // 碳排放量（tCO2）= 燃料消耗量*平均低位发热量*碳排放因子
        {
          value: '',
          label: '无烟煤',
          placeholder: '单位：吨',
          factor: 25.0896 * 0.02749 * 0.94 * 44 / 12
        },
        {
          value: '',
          label: '一般烟煤',
          placeholder: '单位：吨',
          factor: 20.908 * 0.02618 * 0.93 * 44 / 12
        },
        {
          value: '',
          label: '褐煤',
          placeholder: '单位：吨',
          factor: 12.5448 * 0.028 * 0.96 * 44 / 12
        },
        {
          value: '',
          label: '洗精煤',
          placeholder: '单位：吨',
          factor: 25.0896 * 0.0254 * 0.93 * 44 / 12
        },
        {
          value: '',
          label: '其他洗煤',
          placeholder: '单位：吨',
          factor: 25.344 * 0.0254 * 0.90 * 44 / 12
        },
        {
          value: '',
          label: '型煤',
          placeholder: '单位：吨',
          factor: 17.46 * 0.0336 * 0.90 * 44 / 12
        },
        {
          value: '',
          label: '焦炭',
          placeholder: '单位：吨',
          factor: 28.43488 * 0.0294 * 0.93 * 44 / 12
        },
        {
          value: '',
          label: '燃料油',
          placeholder: '单位：吨',
          factor: 40.19 * 0.0211 * 0.98 * 44 / 12
        },
        {
          value: '',
          label: '原油',
          placeholder: '单位：吨',
          factor: 41.816 * 0.0201 * 0.98 * 44 / 12
        },
        {
          value: '',
          label: '汽油',
          placeholder: '单位：吨',
          factor: 43.07048 * 0.0189 * 0.98 * 44 / 12
        },
        {
          value: '',
          label: '煤油',
          placeholder: '单位：吨',
          factor: 43.07048 * 0.0196 * 0.98 * 44 / 12
        },
        {
          value: '',
          label: '柴油',
          placeholder: '单位：吨',
          factor: 42.65232 * 0.0202 * 0.98 * 44 / 12
        },
        {
          value: '',
          label: '石油焦',
          placeholder: '单位：吨',
          factor: 31 * 0.0275 * 0.98 * 44 / 12
        },
        {
          value: '',
          label: '其他石油制品',
          placeholder: '单位：吨',
          factor: 40.19 * 0.02 * 0.98 * 44 / 12
        },
        {
          value: '',
          label: '焦油',
          placeholder: '单位：吨',
          factor: 33.453 * 0.022 * 0.98 * 44 / 12
        },
        {
          value: '',
          label: '粗笨',
          placeholder: '单位：吨',
          factor: 41.816 * 0.0227 * 0.98 * 44 / 12
        },
        {
          value: '',
          label: '天然气',
          placeholder: '单位：万标准立方米',
          factor: 355.436 * 0.0153 * 0.99 * 44 / 12
        },
        {
          value: '',
          label: '炼厂干气',
          placeholder: '单位：万标准立方米',
          factor: 46.05 * 0.0182 * 0.99 * 44 / 12
        },
        {
          value: '',
          label: '液化石油气',
          placeholder: '单位：万标准立方米',
          factor: 47.31 * 0.0172 * 0.99 * 44 / 12
        },
        {
          value: '',
          label: '液化天然气',
          placeholder: '单位：万标准立方米',
          factor: 41.868 * 0.0153 * 0.99 * 44 / 12
        },
        {
          value: '',
          label: '焦炉煤气',
          placeholder: '单位：万标准立方米',
          factor: 173.854 * 0.0136 * 0.99 * 44 / 12
        },
        {
          value: '',
          label: '高炉煤气',
          placeholder: '单位：万标准立方米',
          factor: 37.39 * 0.0708 * 0.99 * 44 / 12
        },
        {
          value: '',
          label: '转炉煤气',
          placeholder: '单位：万标准立方米',
          factor: 79.54 * 0.0496 * 0.99 * 44 / 12
        },
        {
          value: '',
          label: '封闭电石炉炉气',
          placeholder: '单位：万标准立方米',
          factor: 111.19 * 0.03951 * 0.99 * 44 / 12
        },
        {
          value: '',
          label: '其他煤气',
          placeholder: '单位：万标准立方米',
          factor: 52.34 * 0.0122 * 0.99 * 44 / 12
        }
      ],
      [
        {
          value: '',
          label: '外购电力',
          placeholder: '单位：MWh',
          factor: 0.9419
        }
      ],
      [
        {
          value: '',
          label: '外购热力',
          placeholder: '单位：吉焦(GJ)',
          factor: 0.11
        }
      ]
    ]
  },
  // 20--食品烟草酒饮料茶制造--单独算法--ok
  {
    title: ['化石燃料燃烧排放', '工业生产过程排放', '废水厌氧处理', '外购电力', '外购热力'],
    pieChartTitle: ['燃料', '生产过程', '废水处理', '外购电力', '外购热力'],
    input: [
      [
        // 碳排放量（tCO2）= 燃料消耗量*平均低位发热量*碳排放因子
        {
          value: '',
          label: '无烟煤',
          placeholder: '单位：吨',
          factor: 25.0896 * 0.02749 * 0.94 * 44 / 12
        },
        {
          value: '',
          label: '一般烟煤',
          placeholder: '单位：吨',
          factor: 20.908 * 0.02618 * 0.93 * 44 / 12
        },
        {
          value: '',
          label: '褐煤',
          placeholder: '单位：吨',
          factor: 12.5448 * 0.028 * 0.96 * 44 / 12
        },
        {
          value: '',
          label: '洗精煤',
          placeholder: '单位：吨',
          factor: 25.0896 * 0.0254 * 0.93 * 44 / 12
        },
        {
          value: '',
          label: '其他洗煤',
          placeholder: '单位：吨',
          factor: 25.344 * 0.0254 * 0.90 * 44 / 12
        },
        {
          value: '',
          label: '型煤',
          placeholder: '单位：吨',
          factor: 17.46 * 0.0336 * 0.90 * 44 / 12
        },
        {
          value: '',
          label: '焦炭',
          placeholder: '单位：吨',
          factor: 28.43488 * 0.0294 * 0.93 * 44 / 12
        },
        {
          value: '',
          label: '燃料油',
          placeholder: '单位：吨',
          factor: 40.19 * 0.0211 * 0.98 * 44 / 12
        },
        {
          value: '',
          label: '原油',
          placeholder: '单位：吨',
          factor: 41.816 * 0.0201 * 0.98 * 44 / 12
        },
        {
          value: '',
          label: '汽油',
          placeholder: '单位：吨',
          factor: 43.07048 * 0.0189 * 0.98 * 44 / 12
        },
        {
          value: '',
          label: '煤油',
          placeholder: '单位：吨',
          factor: 43.07048 * 0.0196 * 0.98 * 44 / 12
        },
        {
          value: '',
          label: '柴油',
          placeholder: '单位：吨',
          factor: 42.65232 * 0.0202 * 0.98 * 44 / 12
        },
        {
          value: '',
          label: '石油焦',
          placeholder: '单位：吨',
          factor: 31 * 0.0275 * 0.98 * 44 / 12
        },
        {
          value: '',
          label: '其他石油制品',
          placeholder: '单位：吨',
          factor: 40.19 * 0.02 * 0.98 * 44 / 12
        },
        {
          value: '',
          label: '焦油',
          placeholder: '单位：吨',
          factor: 33.453 * 0.022 * 0.98 * 44 / 12
        },
        {
          value: '',
          label: '粗笨',
          placeholder: '单位：吨',
          factor: 41.816 * 0.0227 * 0.98 * 44 / 12
        },
        {
          value: '',
          label: '天然气',
          placeholder: '单位：万标准立方米',
          factor: 355.436 * 0.0153 * 0.99 * 44 / 12
        },
        {
          value: '',
          label: '炼厂干气',
          placeholder: '单位：万标准立方米',
          factor: 46.05 * 0.0182 * 0.99 * 44 / 12
        },
        {
          value: '',
          label: '液化石油气',
          placeholder: '单位：万标准立方米',
          factor: 47.31 * 0.0172 * 0.99 * 44 / 12
        },
        {
          value: '',
          label: '液化天然气',
          placeholder: '单位：万标准立方米',
          factor: 41.868 * 0.0153 * 0.99 * 44 / 12
        },
        {
          value: '',
          label: '焦炉煤气',
          placeholder: '单位：万标准立方米',
          factor: 173.854 * 0.0136 * 0.99 * 44 / 12
        },
        {
          value: '',
          label: '高炉煤气',
          placeholder: '单位：万标准立方米',
          factor: 37.39 * 0.0708 * 0.99 * 44 / 12
        },
        {
          value: '',
          label: '转炉煤气',
          placeholder: '单位：万标准立方米',
          factor: 79.54 * 0.0496 * 0.99 * 44 / 12
        },
        {
          value: '',
          label: '封闭电石炉炉气',
          placeholder: '单位：万标准立方米',
          factor: 111.19 * 0.03951 * 0.99 * 44 / 12
        },
        {
          value: '',
          label: '其他煤气',
          placeholder: '单位：万标准立方米',
          factor: 52.34 * 0.0122 * 0.99 * 44 / 12
        }
      ],
      [
        // 碳酸盐重量*碳酸盐特定碳排放因子*碳酸盐煅烧比例
        {
          value: '',
          label: '碳酸钙',
          placeholder: '单位：吨',
          factor: 0.44
        },
        {
          value: '',
          label: '碳酸镁',
          placeholder: '单位：吨',
          factor: 0.552
        },
        {
          value: '',
          label: '碳酸钠',
          placeholder: '单位：吨',
          factor: 0.415
        },
        {
          value: '',
          label: '碳酸钡',
          placeholder: '单位：吨',
          factor: 0.223
        },
        {
          value: '',
          label: '碳酸锂',
          placeholder: '单位：吨',
          factor: 0.596
        },
        {
          value: '',
          label: '碳酸锰',
          placeholder: '单位：吨',
          factor: 0.38286 * 0.1
        },
        {
          value: '',
          label: '碳酸钾',
          placeholder: '单位：吨',
          factor: 0.318
        },
        {
          value: '',
          label: '碳酸锶',
          placeholder: '单位：吨',
          factor: 0.298
        },
        {
          value: '',
          label: '碳酸氢钠',
          placeholder: '单位：吨',
          factor: 0.524
        },
        {
          value: '',
          label: '碳酸铁',
          placeholder: '单位：吨',
          factor: 0.38
        }
      ],
      [
        // （厌氧处理过程产生的废水量 × 厌氧处理系统进口废水中的化学需氧量浓度 - 以污泥方式清除掉的有机物总量）× 甲烷排放因子 - 甲烷回收量
        {
          value: '',
          label: '行业',
          placeholder: '食品填1，烟草填2，其他填3',
          factor: 0
        },
        {
          value: '',
          label: '厌氧处理过程产生的废水量',
          placeholder: '单位：立方米',
          factor: 0
        },
        {
          value: '',
          label: '厌氧处理系统进口废水中的化学需氧量浓度',
          placeholder: '单位：千克COD/立方米',
          factor: 0
        },
        {
          value: '',
          label: '以污泥方式清除掉的有机物',
          placeholder: '单位：千克COD',
          factor: 0
        },
        {
          value: '',
          label: '甲烷回收量',
          placeholder: '单位：千克甲烷',
          factor: 0
        }
      ],
      [
        {
          value: '',
          label: '外购电力',
          placeholder: '单位：MWh',
          factor: 0.9419
        }
      ],
      [
        {
          value: '',
          label: '外购热力',
          placeholder: '单位：吉焦(GJ)',
          factor: 0.11
        }
      ]
    ]
  },
  // 21--机械设备制造--单独算法--ok
  {
    title: ['化石燃料燃烧排放', '外购电力', '外购热力'],
    pieChartTitle: ['燃料', '外购电力', '外购热力'],
    input: [
      [
        {
          value: '',
          label: '无烟煤',
          placeholder: '单位：吨',
          factor: 20.304 * 0.094748
        },
        {
          value: '',
          label: '烟煤',
          placeholder: '单位：吨',
          factor: 19.57 * 0.0892738
        },
        {
          value: '',
          label: '褐煤',
          placeholder: '单位：吨',
          factor: 14.08 * 0.09856
        },
        {
          value: '',
          label: '型煤',
          placeholder: '单位：吨',
          factor: 14.46 * 0.11088
        },
        {
          value: '',
          label: '焦炭',
          placeholder: '单位：吨',
          factor: 28.447 * 0.100254
        },
        {
          value: '',
          label: '原油',
          placeholder: '单位：吨',
          factor: 41.816 * 0.072226
        },
        {
          value: '',
          label: '燃料油',
          placeholder: '单位：吨',
          factor: 41.816 * 0.075819
        },
        {
          value: '',
          label: '汽油',
          placeholder: '单位：吨',
          factor: 43.07 * 0.067914
        },
        {
          value: '',
          label: '柴油',
          placeholder: '单位：吨',
          factor: 42.652 * 0.07258
        },
        {
          value: '',
          label: '石油焦',
          placeholder: '单位：吨',
          factor: 32.5 * 0.0988
        },
        {
          value: '',
          label: '炼厂干气',
          placeholder: '单位：吨',
          factor: 45.998 * 0.066066
        },
        {
          value: '',
          label: '液化石油气',
          placeholder: '单位：吨',
          factor: 50.179 * 0.062436
        },
        {
          value: '',
          label: '液化天然气',
          placeholder: '单位：吨',
          factor: 41.868 * 0.062436
        },
        {
          value: '',
          label: '天然气',
          placeholder: '单位：万标准立方米',
          factor: 389.31 * 0.055539
        }
      ],
      [
        {
          value: '',
          label: '外购电力',
          placeholder: '单位：MWh',
          factor: 0.9419
        }
      ],
      [
        {
          value: '',
          label: '外购热力',
          placeholder: '单位：吉焦(GJ)',
          factor: 0.11
        }
      ]
    ]
  },
  // 22--电子设备制造--单独算法--ok
  {
    title: ['化石燃料燃烧排放', '工业生产过程（刻蚀工序排放、CVD清洗排放）', '外购电力', '外购热力'],
    pieChartTitle: ['燃料', '生产过程', '外购电力', '外购热力'],
    input: [
      [
        {
          value: '',
          label: '无烟煤',
          placeholder: '单位：吨',
          factor: 20.304 * 0.094748
        },
        {
          value: '',
          label: '烟煤',
          placeholder: '单位：吨',
          factor: 19.57 * 0.0892738
        },
        {
          value: '',
          label: '褐煤',
          placeholder: '单位：吨',
          factor: 14.08 * 0.09856
        },
        {
          value: '',
          label: '型煤',
          placeholder: '单位：吨',
          factor: 14.46 * 0.11088
        },
        {
          value: '',
          label: '焦炭',
          placeholder: '单位：吨',
          factor: 28.447 * 0.100254
        },
        {
          value: '',
          label: '原油',
          placeholder: '单位：吨',
          factor: 41.816 * 0.072226
        },
        {
          value: '',
          label: '燃料油',
          placeholder: '单位：吨',
          factor: 41.816 * 0.075819
        },
        {
          value: '',
          label: '汽油',
          placeholder: '单位：吨',
          factor: 43.07 * 0.067914
        },
        {
          value: '',
          label: '柴油',
          placeholder: '单位：吨',
          factor: 42.652 * 0.07258
        },
        {
          value: '',
          label: '焦油',
          placeholder: '单位：吨',
          factor: 33.453 * 0.07905
        },
        {
          value: '',
          label: '粗苯',
          placeholder: '单位：吨',
          factor: 41.816 * 0.0815687
        },
        {
          value: '',
          label: '炼厂干气',
          placeholder: '单位：吨',
          factor: 45.998 * 0.066066
        },
        {
          value: '',
          label: '液化石油气',
          placeholder: '单位：吨',
          factor: 50.179 * 0.062436
        },
        {
          value: '',
          label: '液化天然气',
          placeholder: '单位：吨',
          factor: 41.868 * 0.062436
        },
        {
          value: '',
          label: '天然气',
          placeholder: '单位：万标准立方米',
          factor: 389.31 * 0.055539
        },
        {
          value: '',
          label: '焦炉煤气',
          placeholder: '单位：万标准立方米',
          factor: 173.54 * 0.043923
        },
        {
          value: '',
          label: '高炉煤气',
          placeholder: '单位：万标准立方米',
          factor: 33 * 0.257004
        },
        {
          value: '',
          label: '转炉煤气',
          placeholder: '单位：万标准立方米',
          factor: 84 * 0.180048
        }
      ],
      [
        {
          value: '',
          label: 'NF3使用量',
          placeholder: '单位：吨',
          factor: 0
        },
        {
          value: '',
          label: 'NF3残余比例',
          placeholder: '单位：%',
          factor: 0
        },
        {
          value: '',
          label: 'SF6使用量',
          placeholder: '单位：吨',
          factor: 0
        },
        {
          value: '',
          label: 'SF6残余比例',
          placeholder: '单位：%',
          factor: 0
        },
        {
          value: '',
          label: 'CF4使用量',
          placeholder: '单位：吨',
          factor: 0
        },
        {
          value: '',
          label: 'CF4残余比例',
          placeholder: '单位：%',
          factor: 0
        },
        {
          value: '',
          label: 'C2F6使用量',
          placeholder: '单位：吨',
          factor: 0
        },
        {
          value: '',
          label: 'C2F6残余比例',
          placeholder: '单位：%',
          factor: 0
        },
        {
          value: '',
          label: 'C4F6使用量',
          placeholder: '单位：吨',
          factor: 0
        },
        {
          value: '',
          label: 'C4F6残余比例',
          placeholder: '单位：%',
          factor: 0
        }
      ],
      [
        {
          value: '',
          label: '外购电力',
          placeholder: '单位：MWh',
          factor: 0.9419
        }
      ],
      [
        {
          value: '',
          label: '外购热力',
          placeholder: '单位：吉焦(GJ)',
          factor: 0.11
        }
      ]
    ]
  }
]
